/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MfaSetup } from '../../models/mfa-setup';

export interface AuthGetMfaAppSetup$Params {
}

export function authGetMfaAppSetup(http: HttpClient, rootUrl: string, params?: AuthGetMfaAppSetup$Params, context?: HttpContext): Observable<StrictHttpResponse<MfaSetup>> {
  const rb = new RequestBuilder(rootUrl, authGetMfaAppSetup.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MfaSetup>;
    })
  );
}

authGetMfaAppSetup.PATH = '/api/Auth/GetMFAAppSetup';
